function Detergent() {
  return (
    <>
      <img
        src={`${window.location.origin}/detergent.jpg`}
        alt="Description of detergent"
        style={{ width: "100%", marginBottom: "10px" }}
      />
    </>
  );
}

export default Detergent;
